import { Grid, Icon, Text } from "@chakra-ui/react";
import type { IconType } from "react-icons";

type LabelValueRowProps = {
  icon: IconType;
  label: string;
  value: React.ReactNode;
};

export function LabelValueRow({ icon, label, value }: LabelValueRowProps) {
  return (
    <Grid
      templateColumns="auto 72px 1fr"
      columnGap={3}
      alignItems="center"
      p={3}
      borderTop="1px solid"
      borderColor="gray.200"
    >
      <Icon as={icon} color="gray.600" boxSize={4} flexShrink={0} />
      <Text
        color="gray.600"
        fontFamily="Work Sans"
        fontWeight={600}
        fontSize="14px"
        lineHeight="130%"
        letterSpacing="0px"
        verticalAlign="middle"
      >
        {label}
      </Text>
      <Text
        color="gray.800"
        fontFamily="Work Sans"
        fontWeight={500}
        fontSize="14px"
        lineHeight="130%"
        letterSpacing="0px"
        verticalAlign="middle"
        minW={0}
      >
        {value}
      </Text>
    </Grid>
  );
}
